import Radio from "backbone.radio";

import strings from "common/strings";

import { ForcePasswordChangeView } from "./forcePasswordChange";
import loginTemplateFrame from "./templateFrame.jst";
import templateBody from "./resetPass.jst";

export const ResetPasswordView = ForcePasswordChangeView.extend({
    template: (data) => loginTemplateFrame({
        partial: templateBody,
        ...data
    }),
    
    changePassword(event) {
        event.preventDefault();

        // Return earlier if prev attempt is still pending
        if (this.waiting) {
            return;
        }

        // Add spinner
        this.addSpinnerToActionButton();

        // Trigger update password
        Radio.channel("login").trigger("updatePassword", {
            onFailed: this.onFailed.bind(this),
            newPassword: this.passwordField.get(),
            token: this.getOption("token"),
            forgotMyPassword: true // Pass this prop to the controller to use different API endpoint
        });
    },
    
    onAttach(...args) {
        if (this.checkTokenExpiration()) {
            ForcePasswordChangeView.prototype.onAttach.call(this, ...args);
        }
    },
    
    checkTokenExpiration() {
        const expiresAt = parseInt(this.getOption("expiresAt"), 10); // UNIX time when token should expire
        const currentTime = +new Date(); // Current UNIX time
        
        if (expiresAt && currentTime > expiresAt) {
            // Token has expired. show error message
            this.showError(strings.login.errors.resetTokenExpired);
            return false;
        }
        
        return true;
    },
    
    showError(message) {
        this.onFailed(message);
        this.$(".new-password").addClass("hidden");
        this.ui.button.addClass("hidden");
        this.$("h2").addClass("hidden");
    },
    
    templateContext() {
        return {};
    }
});
